export const secondary = {
  50: "#e7f2fe",
  100: "#c2dcfc",
  200: "#98c4fa",
  300: "#6eaaf6",
  400: "#5096f4",
  500: "#60a5f1",
  600: "#488fe0",
  700: "#3878c4",
  800: "#2c62a4",
  900: "#1b4477"
};